import React from "react";
import type {
  DescriptionFile,
  DescriptionFileValidation,
} from "../../../../application/domain/proc-management";
import { DescriptionFileInput } from "./description-file-input";
import { ListInput } from "./list-input";
import type { FileInputProps, InputProps, PathProps } from "./types";

const notices = [
  "手続きを説明するために、スライドなどを含むPDFファイル等を利用したい場合に利用します。",
  "手続きの様式などユーザーが記入して使う書類は、この項目ではなく、窓口申請や郵送申請に関する入力欄で添付してください。",
];

type Props = InputProps &
  PathProps &
  FileInputProps & {
    value: DescriptionFile[];
    validationErrors: DescriptionFileValidation[];
  };

export const ProcedureDescriptionFilesListInput: React.FC<Props> = ({
  value,
  onChange,
  disabled,
  basePath,
  onFileAttached,
  getFileUploading,
  shouldDisplayError,
  validationErrors,
}) => {
  return (
    <ListInput
      label="手続き説明用添付ファイル"
      component={DescriptionFileInput}
      componentProps={value.map((v, i) => ({
        ...v,
        onChange,
        onFileAttached,
        getFileUploading,
        shouldDisplayError,
        validationErrors: validationErrors[i],
      }))}
      basePath={basePath}
      onPush={() => {
        onChange(basePath, [...value, { name: "", fileName: "" }]);
      }}
      onRemove={(i) => {
        onChange(basePath, [...value.slice(0, i), ...value.slice(i + 1)]);
      }}
      disabled={disabled}
      notices={notices}
    />
  );
};
